<template>
<div class="chapter">
<div class="inner_page">
<p class="c3"><em class="calibre7"><a class="calibre5" id="page_11"></a>This novel is dedicated<br class="calibre6"/> to my wife,<br class="calibre6"/>
with all my love</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?717b8642